const calculateExcludedVatAmount = (price: number, quantity: number, vatRate: number) => {
    const amount = quantity * price;

    return amount - amount / (1 + vatRate / 100);
};

export default calculateExcludedVatAmount;
